import { IS_SANDBOX_FRONTEND } from "@smartrr/shared/constants";
import { FeatureEnum } from "@smartrr/shared/entities/AccountPlan";
import { Navigate, createLazyFileRoute } from "@tanstack/react-router";

import { ErrorBoundary } from "@vendor-app/app/_sharedComponents/ErrorBoundary";
import { useIsSuperUserSelector } from "@vendor-app/app/_state/reducers/auth";
import { AdminHomeRoute } from "@vendor-app/app/AdminRoute/AdminHomeRoute";
import useSubscriptionEligibility from "@vendor-app/app/AdminRoute/AdminSetupRoute/Tabs/SubscriptionSetup/libs/hooks/useSubscriptionEligibility";
import { AuthorizedRoute } from "@vendor-app/app/AdminRoute/components/authorization/AuthorizedRoute";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";

export const Route = createLazyFileRoute("/admin/home")({
  component: Index,
  errorComponent: ({ error, info }) => <ErrorBoundary error={error} info={info} />,
});

function Index() {
  // The plan check runs first so a merchant without a plan is never redirected into other pages
  return AuthorizedRoute(FeatureEnum.CORE_CONFIGURATION, <HomeContent />);
}

function HomeContent() {
  const isSuperUser = useIsSuperUserSelector();
  const { eligibleForSubscriptions } = useSubscriptionEligibility();
  const { vendorPortalGettingStartedPage: gettingStartedFeatureFlagEnabled } = useSmartrrFlags();

  if (gettingStartedFeatureFlagEnabled && !eligibleForSubscriptions && !isSuperUser && !IS_SANDBOX_FRONTEND) {
    return <Navigate to="/admin/getting-started" />;
  }

  if (!eligibleForSubscriptions && !isSuperUser && !IS_SANDBOX_FRONTEND) {
    return <Navigate to="/admin/setup" />;
  }

  return <AdminHomeRoute />;
}
